// The six cards that fan out from the Octarnal hub in the CapabilityWeb section.
// Each has its own `kind`, which the section renders as a distinct little mockup
// (a stack list, a speed chart, an editor, a search result, device frames, an
// uptime panel). The content is about what a client actually gets from a site we
// ship — fast, findable, theirs to run — deliberately concrete rather than
// design talk or AI hype, and written fresh so it never reads as the Services
// copy. Order matters: 0–2 top row, 3–5 bottom row.
export type CapabilityKind =
  | "stack"
  | "speed"
  | "cms"
  | "seo"
  | "responsive"
  | "uptime";

export interface CapabilityNode {
  id: string;
  title: string;
  blurb: string;
  kind: CapabilityKind;
  /** Names for the chip list. */
  chips?: string[];
}

export const capabilityNodes: CapabilityNode[] = [
  {
    id: "stack",
    title: "Runs On Autopilot",
    blurb:
      "Deploys, backups and form routing take care of themselves — the busywork runs on its own so nothing needs babysitting.",
    kind: "stack",
    chips: [
      "Auto-deploy on push",
      "Nightly backups",
      "Forms to your inbox",
      "SSL auto-renews",
      "24/7 uptime checks",
      "Auto security updates",
    ],
  },
  {
    id: "speed",
    title: "Fast By Default",
    blurb:
      "Core Web Vitals in the green from launch day, because a slow page quietly costs you customers.",
    kind: "speed",
  },
  {
    id: "cms",
    title: "Content You Own",
    blurb:
      "Edit copy, images and pages yourself — no dev queue, no waiting on us to change a single line.",
    kind: "cms",
  },
  {
    id: "seo",
    title: "Found On Google",
    blurb:
      "Clean, semantic markup and real SEO groundwork, so the right people land on you first.",
    kind: "seo",
  },
  {
    id: "responsive",
    title: "Sharp On Every Screen",
    blurb:
      "Pixel-tight from a wide desktop monitor down to the phone in someone's hand.",
    kind: "responsive",
  },
  {
    id: "uptime",
    title: "Scales Without Breaking",
    blurb:
      "Handles a traffic spike without flinching, with monitoring watching around the clock.",
    kind: "uptime",
  },
];
